import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SapAccountSubgroupService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SapAccountSubgroupCreateDto,
  SapAccountSubgroupDto,
  SapAccountSubgroupExcelDownloadDto,
  SapAccountSubgroupUpdateDto,
} from '../proxy/controlling/dtos/sap-account-subgroup';
import { SAPACCOUNTSUBGROUP_CONFIG, SAPACCOUNTSUBGROUP_FIELDS } from './sap-account-subgroup.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-sap-account-subgroup',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SapAccountSubgroupService, ConfirmationService],
  templateUrl: './sap-account-subgroup.html',
  styleUrl: './sap-account-subgroup.scss',
})
export class SapAccountSubgroup extends BaseHierarchicalCrudComponent<
  SapAccountSubgroupDto,
  SapAccountSubgroupCreateDto,
  SapAccountSubgroupUpdateDto,
  SapAccountSubgroupExcelDownloadDto
> {
  service = inject(SapAccountSubgroupService);
  config = SAPACCOUNTSUBGROUP_CONFIG;
  fields = SAPACCOUNTSUBGROUP_FIELDS;

  protected prepareUpdateDto(data: any, selected: SapAccountSubgroupDto): SapAccountSubgroupUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SapAccountSubgroup';
  }
}
